import { defineStore } from "pinia";
import Database from "@/model/Database";
import { getDatabaseManager } from "@/firebase/DatabaseManager";
import { getState } from "../AppState";
import Audit from "@/model/Auditing/Audit";
import * as StringUtils from "@/utils/StringUtils";
import { Role } from "@/model/User";
import { getAuditManager } from "@/firebase/AuditManager";
import Communication from "@/model/Communication/Communication";
import { getCommunicationManager } from "@/firebase/CommunicationManager";
import SecureatTarget from "@/model/Communication/SecureatTarget";
import { DateTime } from "rrule/dist/esm/datetime";
import { collection, doc } from "firebase/firestore";
import * as Firebase from "@/firebase/Firebase";
import Quiz, { QuizQuestion } from "@/model/Communication/Quiz";
import Training from "@/model/Trainings/Training";
import TrainingSection from "@/model/Trainings/TrainingSection";
import { TrainingType } from "@/model/Trainings/TrainingType";
import TrainingCategory from "@/model/Trainings/TrainingCategory";
import { getTrainingManager } from "@/firebase/TrainingManager";
import Store from "@/model/Store";
import { getTrainingsState } from "./TrainingsState";

interface TrainingState {
  training: Training | null;

  initialTraining: Training | null;
  database: Database | null;
  creation: boolean;
  selectedQuestion: QuizQuestion | null;

  selectedSection: TrainingSection | null;

  selectedCategory: TrainingCategory | null;

  categories: TrainingCategory[];
}

export const getTrainingState = defineStore("TrainingState", {
  state: (): TrainingState => {
    return {
      database: null,
      training: null,
      creation: false,
      selectedQuestion: null,
      initialTraining: null,
      selectedSection: null,
      selectedCategory: null,
      categories: [],
    };
  },
  actions: {
    set(database: Database | null, training: Training | null = null) {

      this.database = database;

      var appState = getState();

      if (training == null) {
        let source = null;

        if (appState.userData.role == Role.Customer) {
          var type = TrainingType.store;

          source = getTrainingsState().selectedStore.ref;

        }
        else if (appState.userData.role == Role.Admin) {
          var type = TrainingType.secureat;
        } else if (appState.userData.role == Role.Distributor) {
          if (database == null) {
            var type = TrainingType.distributor;
            source = appState.userData.distributor;
          } else {
            var type = TrainingType.database;
            source = database.ref;
          }
        } else if (appState.userData.role == Role.Manager) {
          var type = TrainingType.database;
          source = database.ref;
        }

        this.initialTraining = new Training(
          doc(collection(Firebase.firestore, "trainings")),
          true,
          appState.userData?.ref!,
          "",
          new SecureatTarget(),
          type,
          [],
          source,
          "FR",
          false,
          null,
        );

        this.creation = true;
      } else {
        this.initialTraining = training;
        this.creation = false;
      }

      if (this.initialTraining.sections.length == 0) {
        this.initialTraining.sections.push(
          new TrainingSection("Nouvelle section", new Quiz([]), null)
        );
      }

      this.training = this.initialTraining.clone();

      this.selectedSection = this.training.sections[0];

      this.selectedQuestion = null;


    },
    async setup() {

      this.categories = await getTrainingManager().getTrainingCategories(this.training);

    },
  },
});
